import {  Main, Product, Footer } from "../components";

function Home() {
 

  return (
    <div > 
        <Main />
        <Product />
        <Footer />
    </div>
     
  
  )
}

export default Home